/**
 * Strip YAML frontmatter from markdown before rendering.
 * Marked treats the closing `---` as a setext h2 underline, which leaks
 * id/title/description into the page as a giant heading.
 */

const FRONTMATTER_RE = /^---\r?\n([\s\S]*?)\r?\n---\r?\n?([\s\S]*)$/;

function unquote(value) {
  const trimmed = value.trim();
  if (
    (trimmed.startsWith('"') && trimmed.endsWith('"')) ||
    (trimmed.startsWith("'") && trimmed.endsWith("'"))
  ) {
    return trimmed.slice(1, -1);
  }
  return trimmed;
}

function parseSimpleFrontmatter(yamlBlock) {
  const result = {};
  for (const line of yamlBlock.split(/\r?\n/)) {
    if (!line.trim() || line.trimStart().startsWith('#') || /^\s+-/.test(line)) {
      continue;
    }
    const match = line.match(/^([A-Za-z0-9_]+):\s*(.*)$/);
    if (!match) continue;
    const [, key, rawValue] = match;
    if (rawValue === '' || rawValue === '|' || rawValue === '>') {
      continue;
    }
    result[key] = unquote(rawValue);
  }
  return result;
}

export function splitMarkdownFrontmatter(raw) {
  if (typeof raw !== 'string' || !raw.startsWith('---')) {
    return { frontmatter: null, body: raw ?? '', title: null };
  }

  const match = raw.match(FRONTMATTER_RE);
  if (!match) {
    return { frontmatter: null, body: raw, title: null };
  }

  const frontmatter = parseSimpleFrontmatter(match[1]);
  return {
    frontmatter,
    body: match[2] ?? '',
    title: frontmatter.title || null
  };
}

export function humanizeDocFilename(filePath) {
  if (!filePath) return '';
  const base = filePath.split('/').pop().replace(/\.md$/i, '');
  return base
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function resolveDocumentDisplayTitle({ metadata, content, currentFile }) {
  if (metadata?.title) return metadata.title;
  const { title } = splitMarkdownFrontmatter(content);
  if (title) return title;
  return humanizeDocFilename(currentFile);
}
